import React from 'react';

const ScoutIcon = (props) => (
  <svg {...props} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='37.02 47.73 233.81 219.53'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M107.741 53.2745L185.223 47.8298C199.273 46.8426 212.779 53.4624 220.655 65.1955L264.088 129.903C271.963 141.637 273.012 156.701 266.838 169.421L232.789 239.574C226.615 252.294 214.157 260.738 200.107 261.726L122.625 267.17C108.576 268.157 95.0694 261.538 87.1938 249.804L43.7606 185.097C35.885 173.363 34.8368 158.299 41.0107 145.579L75.0595 75.4264C81.2335 62.706 93.6916 54.2617 107.741 53.2745Z'
      fill='#FDBF47'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M154.245 221.805C189.495 221.805 218.071 193.089 218.071 157.667C218.071 122.245 189.495 93.5293 154.245 93.5293C118.996 93.5293 90.4204 122.245 90.4204 157.667C90.4204 193.089 118.996 221.805 154.245 221.805ZM175.52 173.706C187.27 173.706 196.795 164.134 196.795 152.327C196.795 140.519 187.27 130.948 175.52 130.948C163.771 130.948 154.245 140.519 154.245 152.327C154.245 164.134 163.771 173.706 175.52 173.706Z'
      fill='#444A52'
    />
  </svg>
);

export default ScoutIcon;
